import React from 'react';
import ENV from '../../env.json';
import WOMPath from '../../worldOfMovies/WOM.path';
import { Link } from 'react-router-dom';
import { MovieCardProps } from './movieCard.interface';
import { connect, ConnectedProps } from 'react-redux';
import { ReduxState } from '../../redux/interface';
import imageNotFound from '../../assets/images/image-not-found.svg';
import { LazyImage } from 'react-lazy-images';
import './movieCard.style.scss';

const MovieCard: React.FC<MovieCardProps & ConnectedProps<typeof connector>> = (
    props: ConnectedProps<typeof connector> & MovieCardProps
) => {

    const { movie } = props;

    return (
        <>
            <div className="wom-movie-card">
                <Link to={WOMPath.movieDetail(movie.id.toString())}>
                    <div className="movie-poster">
                        <LazyImage
                            src={movie.poster_path ? ENV.TMDB_IMAGE + movie.poster_path : imageNotFound}
                            placeholder={({ imageProps, ref }) => (
                                <div className="isLoading" ref={ref}>
                                    <div className="loader poster-loader">
                                        Loading ...
                                    </div>
                                </div>
                            )}
                            actual={({ imageProps }) => <img {...imageProps} alt="image" />}
                        >
                            <img src={movie.poster_path ? ENV.TMDB_IMAGE + movie.poster_path : imageNotFound} alt={movie.title} />
                        </LazyImage>
                    </div>
                </Link>
                <div className="movie-content">
                    <Link to={WOMPath.movieDetail(movie.id.toString())} title={movie.title}>
                        <p>{movie.title}</p>
                    </Link>
                    <span className="vote-average">
                        <i className="material-icons">star</i>
                        <span>{props.movie.vote_average}</span>
                    </span>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: ReduxState) => {
    return {
        genrse: state.genrse,
    };
};

const connector = connect(mapStateToProps);
export default connector(MovieCard);
